// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3uBov","tab":"ProcedureTabs_tab__3ITGZ"};